import type { LanguageObject } from '../types';
import { LANGUAGES } from '../data';

/**
 * Allows lookup of a specific language definition
 *
 * Will always return a language, by returning english if nothing matches.
 *
 * @param value
 * @param attribute
 */
const getLanguage = (value: string, attribute?: string): LanguageObject => {
  //
  // By key
  if (!attribute) {
    return LANGUAGES[value] ?? LANGUAGES.en;
  }

  //
  // By Attribute
  return (
    Object.values(LANGUAGES).find(
      (language) => language[attribute] === value,
    ) ?? LANGUAGES.en
  );
};

export default getLanguage;
